// Auth gate component — shows loading spinner while checking auth state
// Mirrors reference AuthGate.tsx pattern for vanilla JS
import { h } from '@lib/dom/createElement.js';
import { authStore } from '../auth.store.js';
import Spinner from '@components/base/Spinner.js';

/**
 * AuthGate wraps the app root.
 * While auth is not yet initialized, it shows a full-screen loading state.
 * Once initialized, it renders children.
 *
 * @param {HTMLElement} childEl - The app content to show after auth is ready
 * @returns {HTMLElement}
 */
export default function AuthGate(childEl) {
  const container = h('div', { className: 'auth-gate' });

  // Loading screen (shown until isInitialized = true)
  const loadingScreen = h('div', { className: 'auth-gate__loading' },
    Spinner({ size: 'lg', color: 'var(--color-primary)' }),
    h('p', { className: 'auth-gate__text' }, 'Loading...'),
  );

  // Initial render
  const { isInitialized } = authStore.get();
  if (isInitialized) {
    container.appendChild(childEl);
  } else {
    container.appendChild(loadingScreen);
  }

  // React to auth initialization
  authStore.subscribe((state) => {
    if (state.isInitialized && container.contains(loadingScreen)) {
      container.innerHTML = '';
      container.appendChild(childEl);
    }
  });

  return container;
}
